import React from 'react'

export const PlanComparisonTable = () => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse mb-6">
        <thead>
          <tr className="bg-gray-50 dark:bg-gray-800">
            <th className="text-left p-3 border-b-2 dark:border-gray-700">Feature</th>
            <th className="text-center p-3 border-b-2 dark:border-gray-700">Free</th>
            <th className="text-center p-3 border-b-2 bg-green-50 dark:bg-green-900/30">
              Pro
            </th>
            <th className="text-center p-3 border-b-2 dark:border-gray-700">Team</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">Scheduled messages</td>
            <td className="text-center p-3 border-b dark:border-gray-700">3 max</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              Unlimited
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">Unlimited</td>
          </tr>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">File attachments</td>
            <td className="text-center p-3 border-b dark:border-gray-700">❌</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              Up to 10
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">Up to 10</td>
          </tr>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">Recurring messages</td>
            <td className="text-center p-3 border-b dark:border-gray-700">❌</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              ✅
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">✅</td>
          </tr>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">Message history</td>
            <td className="text-center p-3 border-b dark:border-gray-700">7 days</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              90 days
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">90 days</td>
          </tr>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">Reusable templates</td>
            <td className="text-center p-3 border-b dark:border-gray-700">❌</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              ✅
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">✅</td>
          </tr>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">Remove "Sent with Delayed Send" branding</td>
            <td className="text-center p-3 border-b dark:border-gray-700">❌</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              ✅
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">✅</td>
          </tr>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">Centralized billing</td>
            <td className="text-center p-3 border-b dark:border-gray-700">❌</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              ❌
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">✅</td>
          </tr>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">Team administration</td>
            <td className="text-center p-3 border-b dark:border-gray-700">❌</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              ❌
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">✅</td>
          </tr>
          <tr>
            <td className="p-3 border-b dark:border-gray-700">Priority support</td>
            <td className="text-center p-3 border-b dark:border-gray-700">❌</td>
            <td className="text-center p-3 border-b bg-green-50 dark:bg-green-900/30">
              ✅
            </td>
            <td className="text-center p-3 border-b dark:border-gray-700">✅</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}